
























































  import {
    Vue,
    Component,
    Prop,
  } from "@/shared/vuepack";
  import {
  DrivewealthAccountSummary
} from "@/shared/types";
  import _ from "lodash";
  import { Location } from "vue-router";
  import { useDrivewealthStore } from "@/shared/store/drivewealth";
  import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
  import * as RouteNames from "@/employee/route-names";

  @Component
  export default class AccountTypeSubheader extends Vue {
    @Prop({ required: false })
    accountId: number;

    @Prop({ required: false })
    isPreenrollment: number;

    drivewealthStore = useDrivewealthStore();
    drivewealthWizardStore = useDrivewealthWizardStore();

    mounted (): void {
      this.drivewealthStore.loadAccountSummariesV2({});
      this.drivewealthStore.loadAccountClaims({});
    }

    calculatePercentageChange (accountSummary: DrivewealthAccountSummary): number {
      if (!accountSummary) {
        return 0;
      }

      const sumOfInvestmentChange = _.sumBy(accountSummary.holdings, x => {
        return ((x.marketPrice - x.priorClose) * x.openQuantity);
      });

      const previousDayEquityValue = (sumOfInvestmentChange + accountSummary.equityValue);
      const todaysEquityValue = accountSummary.equityValue;

      const percentageChange =  100 * (previousDayEquityValue - todaysEquityValue) / ((previousDayEquityValue + todaysEquityValue) / 2);

      return _.isNaN(percentageChange) ? 0 : percentageChange;
    }

    isPositiveNumber (value: number): boolean {
      return value > 0;
    }

    isNegativeNumber (value: number): boolean {
      return value < 0;
    }

    isZero (value: number): boolean {
      return value === 0;
    }

    formatDisplayFiniteValue (value: number): string {
      if (_.isFinite(value)) {
        return `${value.toFixed(2)}%`;
      }

      return "N/A";
    }

    get displayLearnMoreButton (): boolean {
      return this.$route.name !== RouteNames.DrivewealthLearnMorePages;
    }

    get learnMoreLocation (): Location {
      return {
        name: RouteNames.DrivewealthLearnMorePages,
        params: {
          subpage: "list"
        }
      };
    }

    get isLoaded (): boolean {
        return this.drivewealthStore.accountSummariesV2Loaded &&
          this.drivewealthStore.isAccountClaimsLoaded;
    }
  }
